export default __webpack_public_path__ + "static/media/mobile_background.c1d5b289.png";